<template>
    <div class="d-flex flex-nowrap align-center justify-end full-width">
        <v-tooltip location="top">
            <template v-slot:activator="{props}">
                <div v-bind="props">
                    <v-icon v-if="!packagesNotDeltaPrice && calcPrice.amount > 0" start> mdi-plus </v-icon>
                    {{ $filters.price(packagesNotDeltaPrice ? product.notDeltaPrice : calcPrice) }}
                    <v-icon v-if="currentlySelected" end>mdi-check</v-icon>
                </div>
            </template>
            <span>
                {{ $t('packages.total_price') }}:
                <span>
                    {{ $filters.price(calcTotalPrice(calcPrice)) }}
                </span>
            </span>
        </v-tooltip>
    </div>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator'
    import {TourOfferDeltaButton} from '@/components/tours/search/TourOfferDeltaButton.vue'

    @Component
    export class TourMultipleRoomOfferDelta extends TourOfferDeltaButton {
        @Prop({required: true}) hotelOffer

        get selectedOffer() {
            return this.hotelOffer.rooms.find(
                ({groupedOffers}) =>
                    this.entry.selectedOfferKeys.includes(groupedOffers[0].offerKey) &&
                    this.room.groupedOffers[0].rph === groupedOffers[0].rph
            )
        }
    }

    export default TourMultipleRoomOfferDelta
</script>
